import { Box, Button } from "@mui/material";
import { useState } from "react";
import { OrederManagement } from "./order_lists";
import { WalletReports } from "../reports/wallet_reports";

/**
 * Order Management with a tab strip on top.
 *
 * "Orders" is the existing order list, untouched. "Reports" is the wallet and
 * Razorpay reporting. Kept as a thin wrapper so the 1,000-line order list does
 * not have to grow a tab system of its own -- the route points here instead.
 *
 * Both tabs stay mounted once opened (hidden, not unmounted) so switching back
 * to Orders does not refetch the order list every time.
 */

const PINK = '#ED1E79';
const MUTED = '#6E6478';
const LINE = '#E9E3EE';

const TABS = [
    { key: 'orders', label: 'Orders' },
    { key: 'reports', label: 'Reports' },
];

export function OrderManagementTabs() {
    const [tab, setTab] = useState('orders');
    // Mount a tab's content only after it has first been opened, so the Reports
    // screen does not fire its requests until someone actually looks at it.
    const [seen, setSeen] = useState({ orders: true });

    const open = (key) => { setTab(key); setSeen((s) => ({ ...s, [key]: true })); };

    return (
        <Box>
            <Box sx={{
                display: "flex", gap: "4px", padding: "8px 12px 0",
                borderBottom: `1px solid ${LINE}`, backgroundColor: "#fff",
            }}>
                {TABS.map((t) => (
                    <Button key={t.key} onClick={() => open(t.key)}
                        sx={{
                            textTransform: "none", fontSize: "14px", fontWeight: 700,
                            padding: "8px 16px", borderRadius: "10px 10px 0 0", minWidth: 0,
                            color: tab === t.key ? PINK : MUTED,
                            borderBottom: tab === t.key ? `2px solid ${PINK}` : "2px solid transparent",
                            "&:hover": { backgroundColor: "#FBF4F8" },
                        }}>
                        {t.label}
                    </Button>
                ))}
            </Box>

            <Box hidden={tab !== 'orders'}>
                {seen.orders && <OrederManagement />}
            </Box>
            <Box hidden={tab !== 'reports'}>
                {seen.reports && <WalletReports />}
            </Box>
        </Box>
    );
}

export default OrderManagementTabs;
